export enum LocationType {
  ADDRESS = 'ADDRESS',
  COORDINATES = 'COORDINATES'
}
